var exports = {
  "L": "toggle__kPg75-",
};

module.exports = exports;
